import AWS from 'aws-sdk'
import uniqid from 'uniqid'
import { IdentityPoolId } from '../config'

const fetchUnauthCredentials = (credentials) => {
    return new Promise( (resolve, reject) => {
        if(!credentials) {

            let credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId
            })

            credentials.refresh((err) => {
                if(err) reject(err);
                else resolve(credentials);
            })

        }
        else {
            resolve(credentials);
        }
    })
}
const uploadImage = (credentials, Bucket, file) => {
    return new Promise( (resolve, reject) => {

        fetchUnauthCredentials(credentials).then( credentials => {

            const s3 = new AWS.S3({credentials})
            console.log(file)
            s3.upload({
                Bucket,
                Body: file,
                Key: uniqid() + '_' + file.name,
                ContentType: file.type
            }, (err, res) => {
                if(err) reject(err);
                else resolve(res);
            })

        })

    })
}

export {
    uploadImage
}



// WEBPACK FOOTER //
// ./src/api/vignette.js